<div class="container">
  <router-outlet></router-outlet>
</div>

<div class="loader" *ngIf="isLoading$ | async">
  <mat-spinner diameter="40"></mat-spinner>
</div>
